<template lang="pug">
div
  .card.mb-0.card-primary
    .card-header
      .row.w-100
        .col-12
          h5 {{ $t("ui.member_list") }}
        .form-group.col-12.mb-1.mt-2
          .d-inline-block.mr-2
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.refresh') }}
              b-input-group-text(slot="append")
                label.custom-switch
                  input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="refreshOn" @change="toggleRefresh()")
                  span.custom-switch-indicator
              b-input-group-text(slot="append")
                b-input(v-model="refreshInterval" type="range" min="1" max="5")
              b-input-group-text(slot="append")
                span {{ refreshInterval }} s
        .form-group.col-3.mb-1
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.status') }}
            b-form-select(v-model="memberStatus" :disabled="loading" size="sm" @change="getCpiMemberList(true)")
              option(value="") {{ $t('ui.all') }}
              option(value="FOLLOW-UP") {{ $t('ui.follow_up') }}
              option(value="INTERESTED") {{ $t('ui.interested') }}
              option(value="INVALID") {{ $t('ui.invalid') }}
              option(value="NON-PICKUP") {{ $t('ui.non_pickup') }}
              option(value="REJECTED") {{ $t('ui.rejected') }}
        .form-group.col-3.mb-1(v-if="['MYR'].includes(getCurrencyCode) || this.isUat")
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              i.fa.fa-search
            DebounceInput(autofocus type="number" v-model="searchID" :placeholder="$t('message.search_by_id')" @enter="getCpiMemberList(true)" size="sm")
        .form-group.col-12.mb-1
          SubmitButton(
            :loading="loading"
            icon="fa fa-search"
            :text="$t('ui.search')"
            type="button"
            @click="getCpiMemberList(true)"
            variant="primary"
            size="sm"
          )

    .card-body
      .row
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRow"
            :per-page="getPageSize"
            v-model="currentPage"
            @input="changedPage($event)"
          )
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
        .col-12
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="20%")
                    span(:title="$t('ui.name')") {{ $t("ui.name") }}
                  th(width="20%")
                    span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                  th(width="14%")
                    span(:title="$t('ui.email')") {{ $t('ui.email') }}
                  th.text-center(width="10%" @click="sortOrder('status')")
                    span(:title="$t('ui.status')") {{ $t("ui.status") }}
                    .float-right
                      i(:class="changeSortKey('status')")
                  th.text-center(width="10%")
                      span(:title="$t('ui.tele_status')") {{ $t("ui.tele_status") }}
                  th.text-right(width="12%")
                    span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
              tbody.clusterize-content
                tr(v-if="cpiMemberList.length == 0")
                  td(:colspan="7").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in cpiMemberList")
                  td.text-center
                    span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                  td
                    span.badge.badge-info.mr-2 {{ item.id }}
                    span(:title="item.fullname") {{ item.fullname }}
                  td
                    span(:title="item.phone") {{ item.phone }}
                  td
                    span.small.d-block(:title="item.email") {{ item.email }}
                    span.small.d-block(:title="item.email2") {{ item.email2 }}
                    span.small.d-block(:title="item.email3") {{ item.email3 }}
                  td.text-center
                    span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                  td.text-center
                    span(:title="item.tele_status") {{ item.tele_status }}
                  td.text-right
                    template(v-if="item.status_update != null")
                      span.d-block(:title="item.status_by") {{ item.status_by }}
                      span.d-block(:title="$moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss') }}
                    span(v-else) -

  template(v-if="!['MYR'].includes(getCurrencyCode)")
    .card.mb-0.card-secondary.mt-4
      .card-header
        .row.w-100
          .col-12
            h5 {{ $t("ui.on_call_list") }}
          .form-group.col-12.mb-1.mt-2
            .d-inline-block.mr-2
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $t('ui.refresh') }}
                b-input-group-text(slot="append")
                  label.custom-switch
                    input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="refreshOnOnCall" @change="toggleRefreshOnCall()")
                    span.custom-switch-indicator
                b-input-group-text(slot="append")
                  b-input(v-model="refreshIntervalOnCall" type="range" min="1" max="5")
                b-input-group-text(slot="append")
                  span {{ refreshIntervalOnCall }} s
          .form-group.col-12.mb-1
            SubmitButton(
              :loading="loading2"
              icon="fa fa-search"
              :text="$t('ui.search')"
              type="button"
              @click="getCpiMemberOnCallList(true)"
              variant="primary"
              size="sm"
            )
      .card-body
        .row
          .col-10.mb-1
            b-pagination.float-left(
              size="sm"
              hide-ellipsis
              :total-rows="totalRowOnCall"
              :per-page="getPageSizeCpiOnCall"
              v-model="currentPageOnCall"
              @input="changedPage($event)")
          .col-2.mb-1
            b-input-group(:prepend="$t('ui.page_size')" size="sm")
              b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSizeCpiOnCall" @input="changedPageSizeCpiOnCall" size="sm")
          .col-12
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th(width="20%")
                      span(:title="$t('ui.name')") {{ $t("ui.name") }}
                    th(width="20%")
                      span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
                    th(width="14%")
                      span(:title="$t('ui.email')") {{ $t('ui.email') }}
                    th.text-center(width="10%")
                      span(:title="$t('ui.tele_status')") {{ $t("ui.tele_status") }}
                    th.text-right(width="12%")
                      span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
                    th(width="8%")
                      span(:title="$t('ui.call_type')") {{ $t("ui.call_type") }}
                tbody.clusterize-content
                  tr(v-if="cpiMemberOnCallList.length == 0")
                    td(:colspan="8").text-center
                      span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in cpiMemberOnCallList")
                    td.text-center
                      span(:title="((currentPage - 1) * getPageSizeCpiOnCall + index + 1)") {{ ((currentPage - 1) * getPageSizeCpiOnCall + index + 1) }}
                    td
                      span.badge.badge-info.mr-2 {{ item.id }}
                      span(:title="item.fullname") {{ item.fullname }}
                    td
                      span(:title="item.phone") {{ item.phone }}
                    td
                      small.d-block(:title="item.email") {{ item.email }}
                      small.d-block(:title="item.email2") {{ item.email2 }}
                      small.d-block(:title="item.email3") {{ item.email3 }}
                    td.text-center
                      span(:title="item.tele_status") {{ item.tele_status }}
                    td.text-right
                      template(v-if="item.status_update != null")
                        span.d-block(:title="item.status_by") {{ item.status_by }}
                        span.d-block(:title="$moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.status_update).format('YYYY-MM-DD, HH:mm:ss') }}
                      span(v-else) -
                    td
                      span(:title="item.call_type") {{ item.call_type }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    loading2: false,
    filterBy: "id",
    cpiMemberList: [],
    currentPage: 1,
    totalRow: 0,
    currentPageOnCall: 1,
    totalRowOnCall: 0,
    search: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: "",
    sortType: "",
    memberStatus: "",
    memberTimer: null,
    refreshOn: false,
    refreshInterval: 5,
    refreshChange: "",
    onCallTimer: null,
    refreshOnOnCall: false,
    refreshIntervalOnCall: 5,
    refreshChangeOncall: "",
    cpiMemberOnCallList: [],
    searchID: "",
    isUat: config.isUat
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeCpiMemberList;
    },
    getPageSizeCpiOnCall() {
      return this.$store.getters.pageSizeCpiOnCall;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() { },
  methods: {
    destroyTimer: function() {
      if (this.memberTimer) {
        clearTimeout(this.memberTimer);
      }
      if (this.onCallTimer) {
        clearTimeout(this.onCallTimer);
      } 
    },
    toggleRefresh: function() {
      this.startRefreshTimer();
    },
    toggleRefreshOnCall: function() {
      this.startRefreshTimerOnCall();
    },
    refresh() {
      if(!this.refreshOn)
        this.getCpiMemberList(true)
      else
        this.toggleRefresh();

      if(!this.refreshOnOnCall && (!['MYR'].includes(this.getCurrencyCode) || this.isUat))
        this.getCpiMemberOnCallList(true);
      else
        this.toggleRefreshOnCall();
    },
    startRefreshTimer: function() {
      if (this.memberTimer) {
        clearTimeout(this.memberTimer);
      }
      if (this.refreshOn) {
        this.getCpiMemberList();
        this.memberTimer = setTimeout(() => {
          this.startRefreshTimer();
        }, this.refreshInterval * 1000);
      } else {
        this.refreshChange = "STOPPED";
      }
    },
    startRefreshTimerOnCall: function() {
      if (this.onCallTimer) {
        clearTimeout(this.onCallTimer);
      }
      if (this.refreshOnOnCall) {
        this.getCpiMemberOnCallList();
        this.onCallTimer = setTimeout(() => {
          this.startRefreshTimerOnCall();
        }, this.refreshIntervalOnCall * 1000);
      } else {
        this.refreshChangeOnCall = "STOPPED";
      }
    },
    getCpiMemberList: function(isSearch) {
      let url = config.cpiMemberListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.operatorID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPage,
        page_size: this.getPageSize,
        member_status: this.memberStatus
      };

      if(['MYR'].includes(this.getCurrencyCode) || this.isUat) {
        json.id = this.searchID
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiMemberList = response.data.dt;
                this.totalRow = this.cpiMemberList.length > 0 ? this.cpiMemberList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getCpiMemberOnCallList: function(isSearch) {
      this.selectedMember = null;
      let url = config.cpiMemberOnCallListUrl();

      if (isSearch) this.currentPage = 1;

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.operatorID,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPageOnCall,
        page_size: this.getPageSizeCpiOnCall
      };

      this.loading2 = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading2 = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.cpiMemberOnCallList = response.data.dt;
                this.totalRowOnCall = this.cpiMemberOnCallList.length > 0 ? this.cpiMemberOnCallList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading2 = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeCpiMemberList", pageSize);
      this.currentPage = 1;
      this.getCpiMemberList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getCpiMemberList();
    },
    changedPageSizeCpiOnCall: function(pageSize) {
      this.$store.dispatch("layout/setPageSizeCpiOnCall", pageSize);
      this.currentPageOnCall = 1;
      this.getCpiMemberOnCallList(true);
    },
    changedPageOnCall: function(pageNo) {
      this.currentPageOnCall = pageNo;
      this.getCpiMemberOnCallList();
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getCpiMemberList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
